<template>
    <div id="boxAgendados"> 
        <h3>Agendados</h3> 
        <input type="text" placeholder="Pesquisar em Agendados" v-model="filtro" class="form-control"> <br /> 
        <div class="div-pai ">
          <div v-show="acessoBotoes" class="text-left col-lg-1 botoeslaterais"> 
            <button type="button" class="btn btn-primary" title="Aguardando Atendimento" @click="aguardandoAtendimento" :disabled="habilitarBotoes"> 
              <i class="fa fa-child" aria-hidden="true" v-show="!loadAguardandoAtendimento"></i> 
              <i class="fa fa-circle-o-notch fa-spin" v-show="loadAguardandoAtendimento"></i> 
            </button> 
            <button type="button" class="btn btn-primary" title="Iniciar Atendimento" @click="fazerAtendimento" :disabled="habilitarBotoes"> 
              <i class="fa fa-user" aria-hidden="true" v-show="!loadAtendimento"></i> 
              <i class="fa fa-circle-o-notch fa-spin" v-show="loadAtendimento"></i> 
            </button> 
            <button type="button" class="btn btn-primary" title="Iniciar Atendimento Coletivo" @click="fazerAtendimentoColetivo" :disabled="habilitarBotoes" > 
              <i class="fa fa-users" aria-hidden="true" v-show="!loadColetivo"></i> 
              <i class="fa fa-circle-o-notch fa-spin" v-show="loadColetivo"></i> 
            </button> 
            <button type="button" class="btn btn-info" title="Encaminhar Exame Médico" @click="exameMedico" :disabled="habilitarBotoes"> 
              <i class="fa fa-medkit" aria-hidden="true" v-show="!loadMedico"></i> 
              <i class="fa fa-circle-o-notch fa-spin" v-show="loadMedico"></i> 
            </button> 
            <button type="button" class="btn btn-warning" title="Aguardando Retorno Candidato (Documentação Incompleta, Exame Complementar, etc)" @click="retornoCandidato" :disabled="habilitarBotoes"> 
              <i class="fa fa-retweet" aria-hidden="true" v-show="!loadRetornoCandidato"></i> 
              <i class="fa fa-circle-o-notch fa-spin" v-show="loadRetornoCandidato"></i> 
            </button> 
            <button type="button" class="btn btn-danger" title="Não Compareceu" @click="naoCompareceu" :disabled="habilitarBotoes"> 
              <i class="fa fa-user-times" aria-hidden="true" v-show="!loadNaoCompareceu"></i>  
              <i class="fa fa-circle-o-notch fa-spin" v-show="loadNaoCompareceu"></i>                  
            </button>   
          </div>  
          <div class="divScroll col-lg-11">
            <ul class="list-group col-lg-12" >
              <li v-for="item of filteredData" class="list-group-item text-left"> 
              <span style="width: 275px;display: inline-block;"><strong>Hora Marcada:</strong><small> {{ item.DiaHorario.substr(11, 5) }} </small></span>
              <input style="float: right; width: 18px; height: 18px;" type="checkbox" title="Selecionar" v-model="agendadosSelecionados" :value="item" />
              <br />
              <span style="width: 340px;display: inline-block;">
                <strong>Tipo: </strong>  
                <small v-if="item.TipoAtendimento == 0" class="label label-info"> Admissão </small>
                <small v-if="item.TipoAtendimento == 1" class="label label-danger"> Rescisão </small>
                <small v-if="item.TipoAtendimento == 2" class="label label-default"> Outros </small>
              </span>
               <span style=" display: inline-block;">
                <strong>Coletivo: </strong>  
                <small > {{ item.Coletivo == true ? 'Sim' : 'Não' }} </small> 
              </span>
              <br/>
              <span style=" width: 340px;display: inline-block;"><strong>Nome: </strong> {{ item.Nome }}</span> 
              <span style=" display: inline-block;"><strong>CPF: </strong> {{ item.Cpf }}</span>  
              <span v-if="item.IdFichaAprovacao !== null" style=" width: 340px;display: inline-block;"><strong>Ficha de Aprovação: </strong> {{ item.IdFichaAprovacao }}</span>
              <span v-if="item.RazaoSocial !== null">
              <br/>
              <span><strong>Empresa: </strong> {{ item.RazaoSocial }}</span>
              </span>
              <br/>
              <strong> Obs.: </strong> <small>{{ item.Observacoes }}</small> 
              </li> 
            </ul> 
          </div> 
        </div>
        <div class="col-lg-12">
          <strong style="float:left;" v-if="this.items.length > 0">{{this.items.length}} pessoa(s) agendada(s). </strong>
          <strong style="float:left;" v-else>Não há ninguem agendado.</strong>
        </div>
        <hr />
        <modalAguardarRetorno :agendados="agendadosSelecionados" idModal="modalAguardando" /> 
        <modalTrocaStatusAtendimento ref="mTrocaStatus" :agendamentos="agendadosSelecionados" idModal="modalTrocaStatus" /> 
    </div>
</template>
<script>
import modalAguardarRetorno from './shared/modal/AguardandoRetorno'
import modalTrocaStatusAtendimento from './shared/modal/TrocaStatusAtendimento'
export default{
  name: 'Agendado',
  methods: {
    listar () {
      this.$http.get('agendados?dia=' + this.dia + '&unidade=' + parseInt(localStorage.getItem('Unidade')))
      .then(function (res) {
        this.items = res.body
        this.loadNaoCompareceu = false
        this.loadMedico = false
        this.loadColetivo = false
        this.loadAtendimento = false
      })
      .catch(function (err) {
        this.loadAtendimento = false
        console.log(err)
        this.loadNaoCompareceu = false
        this.loadMedico = false
        this.loadColetivo = false
        this.loadAtendimento = false
      })
    },
    fazerAtendimento () {
      if (this.agendadosSelecionados.length === 0) {
        alert('Você deve selecionar ao menos uma pessoa')
        return false
      }
      // this.loadAtendimento = true
      // let agendamentovm = {
      //   agendamento: this.agendadosSelecionados,
      //   Status: 1,
      //   IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      // }

      $('#modalTrocaStatus').modal('show')
      this.$refs.mTrocaStatus.status = 1
      // this.$refs.mTrocaStatus.confirmar(agendamentovm)
      // this.$http.put('atualizar-status', agendamentovm)
      // .then(function (res) {
      //   location.reload()
      // })
      // .catch(function (err) {
      //   this.loadAtendimento = false
      //   alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
      //   console.log(err)
      // })
    },
    fazerAtendimentoColetivo () {
      if (this.agendadosSelecionados.length <= 1) {
        alert('Você deve selecionar ao menos duas pessoas')
        return false
      }
      $('#modalTrocaStatus').modal('show')
      this.$refs.mTrocaStatus.status = 2
      // this.loadColetivo = true
      // let agendamentovm = {
      //   agendamento: this.agendadosSelecionados,
      //   Status: 2,
      //   IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      // }

      // this.$http.put('atualizar-status', agendamentovm)
      // .then(function (res) {
      //   location.reload()
      // })
      // .catch(function (err) {
      //   this.loadColetivo = false
      //   alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
      //   console.log(err)
      // })
    },
    exameMedico () {
      if (this.agendadosSelecionados.length === 0) {
        alert('Você deve selecionar ao menos uma pessoa')
        return false
      }
      $('#modalTrocaStatus').modal('show')
      this.$refs.mTrocaStatus.status = 4
      // this.loadMedico = true
      // let agendamentovm = {
      //   agendamento: this.agendadosSelecionados,
      //   Status: 4,
      //   IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      // }

      // this.$http.put('atualizar-status', agendamentovm)
      // .then(function (res) {
      //   location.reload()
      // })
      // .catch(function (err) {
      //   this.loadMedico = false
      //   alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
      //   console.log(err)
      // })
    },
    aguardandoAtendimento () {
      if (this.agendadosSelecionados.length === 0) {
        alert('Você deve selecionar ao menos uma pessoa')
        return false
      }
      $('#modalTrocaStatus').modal('show')
      this.$refs.mTrocaStatus.status = 6
      // this.loadAguardandoAtendimento = true
      // let agendamentovm = {
      //   agendamento: this.agendadosSelecionados,
      //   Status: 6,
      //   IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      // }
      // this.$http.put('atualizar-status', agendamentovm)
      // .then(function (res) {
      //   location.reload()
      // })
      // .catch(function (err) {
      //   this.loadAguardandoAtendimento = false
      //   alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
      //   console.log(err)
      // })
    },
    retornoCandidato () {
      if (this.agendadosSelecionados.length === 0) {
        alert('Você deve selecionar ao menos uma pessoa')
        return false
      }
      $('#modalAguardando').modal('show')
    },
    naoCompareceu () {
      if (this.agendadosSelecionados.length === 0) {
        alert('Você deve selecionar ao menos uma pessoa')
        return false
      }
      $('#modalTrocaStatus').modal('show')
      this.$refs.mTrocaStatus.status = 5
      // this.loadNaoCompareceu = true
      // let agendamentovm = {
      //   agendamento: this.agendadosSelecionados,
      //   Status: 5,
      //   IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      // }

      // this.$http.put('atualizar-status', agendamentovm)
      // .then(function (res) {
      //   location.reload()
      // })
      // .catch(function (err) {
      //   this.loadNaoCompareceu = false
      //   alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
      //   console.log(err)
      // })
    }
  },
  computed: {
    habilitarBotoes () {
      return this.agendadosSelecionados.length === 0
    },
    filteredData: function () {
      var filtro = this.filtro && this.filtro.toLowerCase()
      var data = this.items
      if (filtro) {
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filtro) > -1
          })
        })
      }
      return data
    }
  },
  components: {
    modalAguardarRetorno,
    modalTrocaStatusAtendimento
  },
  created: function () {
    this.listar()
  },
  props: ['data', 'acessoBotoes'],
  data () {
    return {
      dia: this.data,
      filtro: '',
      agendadosSelecionados: [],
      search: '',
      items: [],
      loadAtendimento: false,
      loadColetivo: false,
      loadMedico: false,
      loadNaoCompareceu: false,
      loadAguardandoAtendimento: false,
      loadRetornoCandidato: false
    }
  }
}
</script>
<style scoped>
    #boxAgendados{  
      width: 100%;
      background: #fff; 
    } 
    #boxAgendados h3{
      padding: 15px 0;
      background: #23527b;
      color:#fff;
    }
    #boxAgendados thead td{
    padding: 8px 0;
    background: #2d618e;
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    }
    #boxAgendados table td {
      border-color:#fff;
    }
    #boxAgendados tfoot td{ 
    background: #cacaca;
    color: #fff; 
    }
    .div-pai{
      position: relative;    
      display: inline-block;
      width: 100%;
  }
    .divScroll{
      position: relative;
      height: 500px;
      max-height: 500px;
      overflow-y: scroll;
      float: right;
    }
    .botoeslaterais{
      position: absolute;
      z-index: 2;
      height: 240px;
      left: 0px;
      top: 0;
      padding: 0;
    }
    .botoeslaterais button{
      display: inline-block;
      margin: 1px 0 0 0 ;
      width: 40px;
      height: 40px;
    }
</style>



// WEBPACK FOOTER //
// Agendado.vue?18d776de